/**
 * Mends International Group monogram — SVG rendering of the supplied logo
 * concept (navy globe, gold continents, red ribbon, star accent).
 */
export default function Logo({ size = 40, showWordmark = true, className = "" }) {
  const LOGO_URL =
    "https://customer-assets-39nsmqrw.emergentagent.net/job_0a6c2ab1-2ea2-40cf-a6ea-62549a2a9288/artifacts/tsqlpvf0_image.png";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Mends International Group"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        draggable="false"
      />
      {showWordmark && (
        <div className="leading-none">
          <div className="font-display text-[15px] tracking-[0.14em] text-white">
            MENDS
          </div>
          <div className="font-mono text-[9px] tracking-[0.35em] text-gold mt-1">
            INTERNATIONAL GROUP
          </div>
        </div>
      )}
    </div>
  );
}
